export const OPEN_ARTIST_SLUG = "truevined";

const stripAccents = (value: string): string => value.normalize("NFD").replace(/[̀-ͯ]/g, "");

const decodeSlug = (value: string): string => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

export function toArtistSlug(name: string | null | undefined): string {
  return stripAccents(decodeSlug(String(name ?? "")))
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9\s_-]/g, "")
    .replace(/[\s_-]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function artistSearchName(slugOrName: string | null | undefined): string {
  return toArtistSlug(slugOrName).replace(/-/g, " ");
}

export function compactArtistKey(slugOrName: string | null | undefined): string {
  return toArtistSlug(slugOrName).replace(/-/g, "");
}

export const isOpenArtistSlug = (slugOrName: string | null | undefined): boolean =>
  compactArtistKey(slugOrName) === OPEN_ARTIST_SLUG;

export function canonicalArtistPath(pathname: string, resolvedArtistName: string | null | undefined): string | null {
  const segments = String(pathname || "").split("/");
  const index = segments.findIndex(Boolean);
  if (index < 0 || !resolvedArtistName) return null;
  const current = segments[index];
  const canonical = toArtistSlug(resolvedArtistName);
  if (!canonical || isOpenArtistSlug(canonical)) return null;
  if (current === canonical) return null;
  if (compactArtistKey(current) !== compactArtistKey(canonical)) return null;
  segments[index] = canonical;
  return segments.join("/");
}
